;(function ($) {


    $('.animation-chromo__space').rolla([
        {
            selector: '.animation-chromo__space .prologue__img',
            property: 'height',
            unit: 'px',
            start_value: 0,
            start_time: 0.25,
            move: 607,
            duration: 0.35
        }
    ])

    $('.animation-chromo__space2').rolla([
        {
            selector: '.animation-chromo__space2 .prologue__img',
            property: 'height',
            unit: 'px',
            start_value: 0,
            start_time: 0.25,
            move: 607,
            duration: 0.35
        }
    ])

    $('.js-cellsAnim').rolla([
        {
            selector: '.cells__fig2',
            property: 'left',
            unit: '%',
            start_value: 100,
            start_time: 0.15,
            move: -46,
            duration: 0.45
        }
    ])

    $('.sfx-cells-mobile__container').rolla([
        {
            selector: '.sfx-cells-mobile__container',
            property: 'width',
            unit: 'px',
            start_value: 200,
            start_time: 0.15,
            move: 120,
            duration: 0.45
        }
    ])

    $('.sfx-chromo-mobile').rolla([
        {
            selector: '.sfx-chromo-mobile__crop',
            property: 'height',
            unit: 'px',
            start_value: 0,
            start_time: 0.1,
            move: 128,
            duration: 0.8
        }
    ])


})(jQuery);
